import React, { useState } from "react";
import { Drawer } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import { LogoutOutlined, MenuOutlined } from "@ant-design/icons";
import med from "../../assets/images/logo.png";
import { useAppStore } from "../../store";
import { NAV_ITEMS, activeNavKey } from "./nav-items";
import NotificationsBell from "./notifications-bell";

export default function Header() {
  const { doctor, logOut } = useAppStore();
  const location = useLocation();
  const activeKey = activeNavKey(location.pathname);
  const [open, setOpen] = useState(false);

  const showDrawer = () => setOpen(true);
  const onClose = () => setOpen(false);
  const onLogout = () => {
    onClose();
    logOut();
  };

  const displayName = doctor?.user?.fullname ?? "";

  return (
    <>
      <header
        className="flex h-full w-full items-center justify-between border-b border-slate-100 bg-white px-4 lg:px-8"
        role="banner"
      >
        <div className="min-w-0 flex-1">
          <h2 className="truncate text-base font-bold tracking-tight text-slate-800 lg:text-2xl">
            Welcome, <span className="text-[#0070C0]">{displayName || "Doctor"}</span>
          </h2>
          <p className="mt-0.5 truncate text-xs text-slate-400 lg:text-sm">
            How can we help you stay healthy today.
          </p>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <NotificationsBell />
          <button
            type="button"
            onClick={showDrawer}
            className="flex h-10 w-10 items-center justify-center rounded-xl text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600 lg:hidden"
            aria-label="Open menu"
          >
            <MenuOutlined className="text-lg" />
          </button>
        </div>
      </header>

      <Drawer
        title={<img src={med} alt="Medpharma" className="h-7 w-auto object-contain" />}
        width={300}
        open={open}
        onClose={onClose}
        styles={{
          body: { padding: 12 },
          header: {
            borderBottom: "1px solid rgba(0, 162, 248, 0.12)",
            padding: "16px 24px",
          },
        }}
      >
        <ul className="m-0 flex list-none flex-col gap-1 p-0">
          {NAV_ITEMS.map(({ key, label, path, icon }) => {
            const isActive = key === activeKey;
            return (
              <li key={key}>
                <NavLink
                  to={path}
                  onClick={onClose}
                  className={`flex items-center gap-3 rounded-xl px-3 py-3 text-[15px] font-medium transition-colors ${
                    isActive
                      ? "bg-[#EAF6FF] text-[#0070C0]"
                      : "text-slate-500 hover:bg-slate-50 hover:text-slate-700"
                  }`}
                >
                  <span className={`flex text-[18px] ${isActive ? "text-[#00A2F8]" : "text-slate-400"}`}>
                    {icon}
                  </span>
                  <span>{label}</span>
                </NavLink>
              </li>
            );
          })}
          <li>
            <div className="my-2 h-px bg-slate-100" />
            <button
              type="button"
              onClick={onLogout}
              className="flex w-full items-center gap-3 rounded-xl px-3 py-3 text-[15px] font-medium text-slate-500 transition-colors hover:bg-red-50 hover:text-red-600"
            >
              <LogoutOutlined className="text-[18px]" />
              <span>Logout</span>
            </button>
          </li>
        </ul>
      </Drawer>
    </>
  );
}
